import { flushPersistedQueryCache } from '../query/persistFlushRegistry';

function isOfflineQueuedMutation(mutation) {
  return Boolean(mutation?.options?.meta?.offlineQueue);
}

function shouldPersistMutation(mutation) {
  if (!isOfflineQueuedMutation(mutation)) return false;
  const { status, isPaused } = mutation.state;
  return status === 'pending' || isPaused || status === 'error';
}

/**
 * Persist immediately when offline-queue mutations change.
 * Background sync flush handles app pause; this covers foreground queue updates.
 */
export function initOfflineMutationPersist(queryClient) {
  return queryClient.getMutationCache().subscribe((event) => {
    const mutation = event?.mutation;
    if (!mutation || !shouldPersistMutation(mutation)) return;
    void flushPersistedQueryCache();
  });
}
